module.exports = __webpack_public_path__ + "img/20.cfd41b97.gif";